// extracted by mini-css-extract-plugin
export default {"wrap":"AA-z","logoContainer":"BA-z","brandImg":"CA-z","logoImg":"DA-z","logoButton":"EA-z"};